// ! FIX ME: Refactor this
import {
  JsonApiQueryParameters,
  formatQueryForJsonApi,
  transformResponseFromJsonApi,
} from '@evolve/common-ui';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from 'evolve-ui';

export type IPostalCode = {
  postalCode: string;
};

export const postalCodesApi = createApi({
  reducerPath: 'postalCodes',
  baseQuery: fetchBaseQuery({
    // ! FIX ME: Change this
    baseUrl: `${process.env.GATSBY_COMMUNICATIONS_API_URL}/addresses`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['PostalCodes'],
  endpoints: (builder) => ({
    getPostalCodes: builder.query<
      { values: IPostalCode[] },
      JsonApiQueryParameters
    >({
      providesTags: ['PostalCodes'],
      query: (params) => formatQueryForJsonApi(params, 'postal-codes'),
      transformResponse: transformResponseFromJsonApi<IPostalCode>,
    }),
  }),
});

export const { useGetPostalCodesQuery } = postalCodesApi;
